"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateClientHotelBedOptions = void 0;
const addOrderLog_1 = require("./addOrderLog");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineById_1 = require("./getOrderLineById");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
const updateClientHotelBedOptions = async (supabase, order_line_id, variant_id, val) => {
    const order_line = await (0, getOrderLineById_1.getOrderLineById)(supabase, order_line_id);
    if (!order_line.versions)
        throw new Error("No versions found");
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
    if (!latest_version)
        throw new Error("No latest version found");
    (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
        ...latest_version,
        config: val,
    });
    const { data } = await supabase
        .from("order_variants")
        .select("*")
        .eq("id", variant_id)
        .single();
    const v = data;
    if (!v.config) {
        v.config = {
            legs: [],
            tee_times_confirmed: {},
            hotel_bed_options: {},
            airport_transfers_confirmed: {},
            transfer_address_details_confirmed: {},
        };
    }
    v.config = {
        ...v.config,
        hotel_bed_options: {
            ...v?.config?.hotel_bed_options,
            [order_line.id]: true,
        },
    };
    await supabase
        .from("order_variants")
        .update({ config: v.config })
        .eq("id", v.id);
    await (0, addOrderLog_1.addOrderLog)(supabase, {
        type: "HOTEL",
        order_id: order_line.order_id,
        detail: {
            type: `Tee Times`,
            status: null,
            title: "Hotel Rooms Bed Configuration Confirmed",
            message: `Hotel room bed configuration at ${val?.where_when_who?.hotel?.name?.en} has been confirmed`,
        },
    });
};
exports.updateClientHotelBedOptions = updateClientHotelBedOptions;
